import {$host} from "@/services/index";

export const createSpeciesPhoto = async (file, species, description) => {
    const formData = new FormData
    formData.append('file', file)
    formData.append('species', species)
    formData.append('description', description)
    const { data } = await $host.post('photo-of-species-in-nature/', formData)
    return data
}

export const fetchSpeciesPhoto = async (species, taxonomy, labelName) => {
    const { data } = await $host.get('photo-of-species-in-nature/', { params: {species, taxonomy, labelName} })
    return data
}

export const updateSpeciesPhotoDescription = async (species, index, description) => {
    const formData = new FormData
    formData.append('description', description)
    const { data } = await $host.patch(`photo-of-species-in-nature/${species}/${index}/description`, formData)
    return data
}

export const updateSpeciesPhotoImage = async (species, index, file) => {
    const formData = new FormData
    formData.append('file', file)
    const { data } = await $host.patch(`photo-of-species-in-nature/${species}/${index}/image`, formData)
    return data
}

export const deleteSpeciesPhoto = async (species, index) => {
    const { data } = await $host.delete('photo-of-species-in-nature/', { params: {species, index}})
    return data
}